const XHR_STATUS = { INITIAL: 0, LOADING: 1, SUCCESS: 2, ERROR: 3 };

export default XHR_STATUS;
